import { Root } from '@studio/design-system/button';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { OrthogonalProps } from './types.js';
import { Sel, STagNew } from '#~/stag/tag.js';

/** `<Orthogonal>` button component. */
export const Orthogonal = ({ className, direction, ...props }: OrthogonalProps): ReactElement => (
  // Per playwright-stag-selectors-only (ai.knowledge/platform): each
  // direction button gets a stable stag keyed on the Direction enum
  // value. `data-direction` is preserved — it is the PRODUCTION
  // contract that choreographer.tsx:27 reads via getTargetIntent to
  // decide which axis to drive. The stag is additional, not a replacement.
  <Root
    className={twMerge('group absolute h-1/3 w-1/3', className)}
    data-direction={direction}
    tabIndex={-1}
    {...STagNew(Sel.MainRoomRightTrayControls, 'dpad-direction', direction)}
    {...props}
  >
    <svg viewBox='0 0 76 76'>
      <path
        className='fill-base-100 transition-colors group-hover:fill-secondary group-active:fill-primary'
        d='M70 65.8583C70 69.2376 65.9691 71.1952 63.0472 69.5011C55.5578 65.1586 46.8595 63.0124 37.5811 63.0124C28.6643 63.0124 20.1237 65.4679 12.8366 69.5011C9.9224 71.114 5.99999 69.154 5.99999 65.8213L5.99999 9.03472C5.99999 6.36293 7.92413 3.99808 10.5177 3.36443C19.1915 1.24532 28.2552 0.121829 37.5811 0.12183C47.284 0.121831 56.7031 1.33799 65.6945 3.62631C68.2621 4.27977 70 6.63165 70 9.28301L70 65.8583Z'
      />
      <path
        className='fill-muted transition-colors group-hover:fill-foreground group-active:fill-foreground'
        d='M37.0992 22.5352C37.4996 21.8216 38.5004 21.8216 38.9008 22.5352L48.3591 39.3944C48.7594 40.108 48.259 41 47.4583 41L28.5417 41C27.741 41 27.2406 40.108 27.6409 39.3944L37.0992 22.5352Z'
      />
    </svg>
  </Root>
);
